export var DateTimePickerDefaultValues;
(function (DateTimePickerDefaultValues) {
    DateTimePickerDefaultValues["DEFAULT_LOCALE"] = "en";
    DateTimePickerDefaultValues["DEFAULT_FORMAT"] = "YYYY-MM-DD";
})(DateTimePickerDefaultValues || (DateTimePickerDefaultValues = {}));
//# sourceMappingURL=DateTimePickerDefaultValues.js.map